<!-- Przycisk dodawania -->
<div class="flex items-end justify-end mb-6 px-2 sm:px-0">
  <span
    pTooltip="Wszystkie pozycje zostały już wybrane"
    tooltipPosition="top"
    [tooltipDisabled]="availableWorkItems.length > 0"
  >
    <p-button
      label="Dodaj nowy rekord"
      (onClick)="addEmptyRow()"
      icon="pi pi-plus"
      outlined
      [disabled]="availableWorkItems.length === 0"
    ></p-button>
  </span>
</div>

<!-- Wrapper tabeli / kart -->
<div class="overflow-x-auto">
  <div class="min-w-full">
    <!-- Desktop table -->
    <p-table
      [value]="entriesByProject"
      styleClass="p-datatable-gridlines w-full hidden md:table"
      rowHover="true"
      showGridlines
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="w-100">Pozycja</th>
          <th
            *ngFor="let day of weekDays; let i = index"
            class="text-sm w-12 whitespace-nowrap bus-text-center"
            [ngClass]="{ 'weekend-header': i === 5 || i === 6 }"
          >
            {{ day.label }}
          </th>
          <th class="bus-text-right total-header">Total</th>
          <th class="remove-col"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td>
            <ng-container *ngIf="row.workItemId; else workItemSelect">
              <div class="flex items-center truncate">
                <span
                  class="w-1 self-stretch rounded me-3 flex-shrink-0"
                  [style.background-color]="row.color || 'var(--app-border)'"
                  [title]="'Kolor: ' + (row.color || 'brak')"
                ></span>

                <div class="flex items-center gap-1 truncate">
                  @if (isOwner()) {
                    <span *ngIf="row.workItemName" class="font-medium truncate">
                      <a
                        [routerLink]="['/work-items', row.workItemId]"
                        class="hover:underline text-primary-600 dark:text-primary-300"
                      >
                        {{ row.workItemName }}
                      </a>
                    </span>
                  } @else {
                    <span *ngIf="row.workItemName" class="font-medium truncate">
                      {{ row.workItemName }}
                    </span>
                  }

                  <span *ngIf="!row.workItemName" class="font-medium truncate">
                    {{ row.clientName }}
                  </span>

                  <small *ngIf="row.workItemName" class="text-gray-500 dark:text-gray-400 truncate">
                    {{ row.clientName ? ' - ' + row.clientName : '' }}
                  </small>
                </div>
              </div>

              <span
                *ngIf="row.billingMode"
                class="ml-3 inline-flex items-center rounded-full px-2 py-0.5 text-[0.7rem] font-semibold uppercase tracking-wide"
                [ngClass]="{
                  'bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-200': row.billingMode === 'HOURLY_RATE',
                  'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-200': row.billingMode === 'REVENUE_THRESHOLD'
                }"
              >
                {{ formatBillingMode(row.billingMode) }}
              </span>
            </ng-container>

            <ng-template #workItemSelect>
              <p-select
                [options]="availableWorkItems"
                optionLabel="name"
                optionValue="id"
                [(ngModel)]="row.workItemId"
                placeholder="Wybierz pozycję"
                (onChange)="onProjectSelected($event, row)"
                [emptyMessage]="'Wszystkie pozycje zostały już wybrane'"
                appendTo="body"
              ></p-select>
            </ng-template>
          </td>

          <td
            *ngFor="let entry of row.timeEntries; let i = index"
            [ngClass]="{ 'bus-text-center': true, 'weekend-cell': i === 5 || i === 6 }"
          >
            <button
              type="button"
              class="timesheet-cell-button"
              [disabled]="!row.workItemId"
              [class.timesheet-cell-button-empty]="entry.duration === 0"
              (click)="openCell(row, entry, i)"
            >
              <span class="timesheet-cell-duration">
                {{ entry.duration ? formatMinutesForInput(entry.duration) : '+' }}
              </span>
              <small *ngIf="entry.entryCount && entry.entryCount > 1" class="timesheet-cell-count">
                {{ entry.entryCount }} wpisy
              </small>
              <small *ngIf="!row.workItemId" class="timesheet-cell-hint">
                Wybierz pozycję
              </small>
            </button>
          </td>

          <td class="bus-text-right w-20 font-semibold total-cell">
            {{ formatMinutesForInput(getRowTotalMinutes(row)) }}
          </td>

          <td class="bus-text-center remove-col">
            <i
              [ngClass]="{
                'pi pi-times remove-icon': true,
                disabled: row.isTemp && entriesByProject.length === 1,
              }"
              style="cursor: pointer; font-size: 0.8em"
              (click)="removeRow(row, rowIndex)"
            ></i>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr>
          <td class="font-semibold text-left">Total dni</td>
          <td
            *ngFor="let day of weekDays; let i = index"
            [ngClass]="{ 'bus-text-center': true, 'weekend-cell': i === 5 || i === 6 }"
          >
            {{ formatMinutesForInput(getDayTotalMinutes(i)) }}
          </td>
          <td class="bus-text-right font-semibold total-cell">
            {{ formatMinutesForInput(getWeekTotalMinutes()) }}
          </td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Mobile stacked cards -->
    <div class="space-y-4 md:hidden px-2">
      <div
        *ngFor="let row of entriesByProject; let rowIndex = index"
        class="mobile-card shadow-md rounded-xl p-4 border"
      >
        <div class="flex justify-between items-center mb-3">
          <div class="text-lg font-semibold text-slate-900 dark:text-slate-50">
            <ng-container *ngIf="row.workItemId; else workItemSelectMobile">
              {{ row.workItemName }}
            </ng-container>

            <ng-template #workItemSelectMobile>
              <p-select
                [options]="availableWorkItems"
                optionLabel="name"
                optionValue="id"
                [(ngModel)]="row.workItemId"
                placeholder="Wybierz pozycję"
                (onChange)="onProjectSelected($event, row)"
                [emptyMessage]="'Wszystkie pozycje zostały już wybrane'"
                appendTo="body"
              ></p-select>
            </ng-template>
          </div>

          <span
            *ngIf="row.billingMode"
            class="inline-flex items-center rounded-full px-2 py-0.5 text-[0.7rem] font-semibold uppercase tracking-wide"
            [ngClass]="{
              'bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-200': row.billingMode === 'HOURLY_RATE',
              'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-200': row.billingMode === 'REVENUE_THRESHOLD'
            }"
          >
            {{ formatBillingMode(row.billingMode) }}
          </span>

          <button
            (click)="removeRow(row, rowIndex)"
            class="remove-te-icon rounded-full p-1 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
            [disabled]="row.isTemp && entriesByProject.length === 1"
          >
            <i class="pi pi-times text-xl"></i>
          </button>
        </div>

        <div class="grid grid-cols-2 gap-3 mb-3">
          <div *ngFor="let entry of row.timeEntries; let i = index" class="flex flex-col">
            <span class="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
              {{ weekDays[i].label }}
            </span>
            <button
              type="button"
              class="timesheet-cell-button mobile-timesheet-cell-button"
              [disabled]="!row.workItemId"
              [class.timesheet-cell-button-empty]="entry.duration === 0"
              (click)="openCell(row, entry, i)"
            >
              <span class="timesheet-cell-duration">
                {{ entry.duration ? formatMinutesForInput(entry.duration) : '+' }}
              </span>
              <small *ngIf="entry.entryCount && entry.entryCount > 1" class="timesheet-cell-count">
                {{ entry.entryCount }} wpisy
              </small>
              <small *ngIf="!row.workItemId" class="timesheet-cell-hint">
                Wybierz pozycję
              </small>
            </button>
          </div>
        </div>

        <p-divider />

        <div class="flex justify-end items-center mt-2 pt-2">
          <span class="text-slate-800 font-semibold dark:text-slate-100">
            Total: {{ formatMinutesForInput(getRowTotalMinutes(row)) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
